<template>
<div class="game_container">
    <div class="game_top_box">
    <div class="game_top_img">
        <img :src="topbgSrc" width="100%" height="100%" alt="" />
    </div>
    <div class="game_top_title">EPISODE 3</div>
    <div class="top_button_box" v-if="alreadyApply == false">
        <button class="top_button" v-on:click="applyJoinGameEvent" :disabled="isDisable">
        COUNT ME IN
        </button>
    </div>
    </div>

    <div class="game_center_box">
    <img :src="centerbgSrc" width="100%" height="100%" alt="" />
    <div class="game_center_txt">
        GAME SLOT: {{gameSlot}}
    </div>
    <div v-if="alreadyApply">
        <div class="game_center_right_title">
            YOU'RE IN
        </div>
        <div class="game_center_right_subtitle">
            if you really have to leave the game, <span class="game_button_right_txt_span" v-on:click="exitGameEvent">click here</span>
        </div>
    </div>
    <div v-else>
        <div class="game_center_right_txt">
            Registration is open until {{deadline}}
        </div>
        <div class="game_center_button">
            <button class="top_button" v-on:click="applyJoinGameEvent" :disabled="isDisable">
            COUNT ME IN
            </button>
        </div>
    </div>
    </div>
    <div class="game_bottom_box">
    <div class="game_bottom_img">
        <img :src="bottombgSrc" width="100%" height="100%" alt="" />
    </div>
    <div class="game_bottom_left_txt">
        The prizes are...
    </div>
    <div v-if="alreadyApply">
        <div class="game_bottom_right_title">
            YOU'RE IN
        </div>
        <div class="game_bottom_right_subtitle">
            if you really have to leave the game, <span class="game_button_right_txt_span" v-on:click="exitGameEvent">click here</span>
        </div>
    </div>
    <div v-else>
        <div class="game_bottom_right_txt">
            Registration is open until {{deadline}}
        </div>
        <div class="bottom_button_box">
        <button class="top_button" v-on:click="applyJoinGameEvent" :disabled="isDisable">
            COUNT ME IN
        </button>
        </div>
    </div>
    </div>

    <div :class="dialogVisible ? 'float_bg_box_color':'float_bg_box'">
    <div :class="dialogVisible ? 'float_box' : 'show-float'" :style="floatBackground">
        <div class="float_title">YOU ARE IN! </div>
        <div class="float_content">see you on the leaderboard!</div>

        <button class="float_button" v-on:click="sureEvent">
        SURE
        </button>
    </div>
    </div>

</div>

</template>

<script>
  import api from '../api/http';
  import {
    Message
  } from 'element-ui';

  export default {
    name: 'CyclingApply',
    data() {
      return {
        isMobile: false,
        topbgSrc: require('../assets/game-1.png'),
        centerbgSrc: require('../assets/game-2.png'),
        bottombgSrc: require('../assets/game-3.png'),
        floatBackground: {
        backgroundImage: 'url(' + require('../assets/float-bg.png') + ')'
        },
        dialogVisible: false,
        gameSlot: '',
        deadline: '',
        alreadyApply: false,
        stopApply: true,
        isDisable: false,
      }
    },
    
    methods: {
      getGameInfoEvent()  {
          let query = this.$route.query;
          let mail = query.email;
          if (mail == 'null' || mail == '' || mail == 'undefined') {
              Message.error('server error');
              return
          }
          let params = {
              'email': mail
          }
          api.get('client-api/v1/game/info', params).then((res) => {
              if (res.data.code == 200) {
                  let data = res.data.data;
                  this.gameSlot = data.gameSlot;
                  this.deadline = data.deadline;
                  this.alreadyApply = data.alreadyApply;
                  this.stopApply = data.stopApply;
              } else {
                  Message.error(res.data.msg);
                  return
              }
          }).catch (error => {
              Message.error(error);
          })
      },
      applyJoinGameEvent() {
          this.isDisable = true;
          if(this.stopApply) {
              this.$router.push('/pc-rttt-4-rank');
              return;
          }
          let query = this.$route.query;
          let mail = query.email;
          if (mail == 'null' || mail == '' || mail == 'undefined') {
              Message.error('server error');
              return
          }
          let params = {
              'email': mail
          }
          api.post('client-api/v1/game/apply', params).then((res) => {
              this.isDisable = false;
              if (res.data.code == 200) {
                  this.dialogVisible = true;
              } else {
                  Message.error(res.data.msg);
                  return
              }
          }).catch (error => {
              this.isDisable = false;
              Message.error(error);
          })
      },
      exitGameEvent() {
          let query = this.$route.query;
          let mail = query.email;
          if (mail == 'null' || mail == '' || mail == 'undefined') {
              Message.error('server error');
              return
          }
          let params = {
              'email': mail
          }
          api.post('client-api/v1/game/apply/cancel', params).then((res) => {
              if (res.data.code == 200) {
                  this.alreadyApply = false;
              } else {
                  Message.error(res.data.msg);
                  return
              }
          }).catch (error => {
              Message.error(error);
          })
      },
      sureEvent() {
          this.dialogVisible = false;
          this.alreadyApply = true;
      }
    },
    mounted() {
      this.getGameInfoEvent();
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
  @import '../fonts/font.css';

  /**  pc style */
  .game_container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    min-width: 1024px;
  }

  .game_top_box {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .game_top_img {
    width: 100%;
    height: auto;
    font-size: 0;
  }
  .game_top_title {
    position: absolute;
    bottom: 36%;
    left: 7%;
    color: rgba(255, 255, 255, 0.8);
    font-family: Montserrat-Medium;
    font-size: 36px;
  }
  .top_button_box {
    position: absolute;
    bottom: 20%;
    left: 7%;
  }

  .top_button {
    width: 320px;
    height: 60px;
    font-size: 20px;
    border: 0;
    margin: 0;
    color: #ffffff;
    background: linear-gradient(135deg, #7d00ff 0%, #8f0af5 49%, #ff5fa2 100%);
    box-shadow: 0 12px 16px 0 rgba(143, 10, 245, 0.35), 0 17px 50px 0 rgba(255, 95, 162, 0.35);
    font-family: Montserrat-Bold;
    font-weight: bold;
    cursor: pointer;
  }

  .game_center_box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #F6F2F7;
    position: relative;
    width: 100%;
  }

  .game_center_txt {
    position:absolute;
    left: 10.5%;
    top: 20%;
    color: rgba(255, 255, 255, 0.8);
  }
  .game_center_right_txt {
    position:absolute;
    right: 5.5%;
    top: 16.5%;
    color: rgba(255, 255, 255, 0.7);
    width: 360px;
    text-align: right;
  }
  
  .game_center_right_title {
    position:absolute;
    right: 5.5%;
    top: 17%;
    color: rgba(255, 255, 255, 0.9); 
    width: 380px; 
    text-align: center;
    font-family: Montserrat-Bold;
    font-size: 24px;
    font-weight: bold;
  }
  .game_center_right_subtitle {
    position: absolute;
    right: 5.5%;
    top: 22.5%;
    color: rgba(255, 255, 255, 0.7);
    width: 380px;
    line-height: 20px;
  }

  
  .game_center_button {
    position:absolute;
    right: 5.5%;
    top: 20.5%;
    color: rgba(255, 255, 255, 0.7);   
  }
  
  .game_center_title {
    font-size: 36px;
    color: #333333;
    margin-top: 50px;
  }

  .game_bottom_box {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;
  }
  .game_bottom_left_txt {
    position:absolute;
    left: 10.5%;
    top: 14%;
    color: rgba(255, 255, 255, 0.8);
  }
  .game_bottom_right_title {
      position:absolute;
      right: 5%;
      top: 12%;
      color: rgba(255, 255, 255, 0.9); 
      width: 380px; 
      text-align: center;
      font-family: Montserrat-Bold;
      font-size: 24px;
      font-weight: bold;
  }
  .game_bottom_right_subtitle {
      position: absolute;
      right: 5%;
      top: 15.5%;
      color: rgba(255, 255, 255, 0.7);
      width: 380px;
      line-height: 20px;
  }
  .game_bottom_right_txt {
    position:absolute;
    right: 5.5%;
    top: 11%;
    color: rgba(255, 255, 255, 0.7);
    width: 360px;
    text-align: right; 
  }

  .bottom_button_box {
    position: absolute;
    right: 5.5%;
    top: 14%;
  }

  .game_button_right_txt_span {
      color: #8505FB;
      cursor: pointer;
      /* text-decoration: underline; */
  }

  .game_bottom_img {
    width: 100%;
    height: auto;
    font-size: 0;
  }

  .game_footer {
    height: auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .footer_text {
    font-size: 36px;
    color: #fff;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .footer_description {
    margin-top: 60px;
    font-size: 16px;
    color: rgba(255, 255, 255, 0.8);
    width: 600px;
  }

  .float_bg_box {
    display: none;
    position: absolute;
    width: 100%;
    height: 370%;
    left: 0;
    top: 0;
  }

  .float_bg_box_color {
    display: block;
    background: rgba(0, 0, 0, 0.7);
    position: absolute;
    width: 100%;
    height: 370%;
    left: 0;
    top: 0;
  }

  .float_box {
    display: block;
    width: 880px;
    height: 480px;
    position: fixed;
    left: calc(50% - 440px);
    top: calc(20%);
  }

  .float_title {
    color: #fff;
    font-size: 36px;
    font-weight: 600;
    margin-top: 114px;
    font-family: Montserrat-Bold;
  }

  .float_content {
    font-size: 24px;
    font-weight: 400;
    letter-spacing: 1px;
    color: #fff;
    margin-top: 24px;
    font-family: Montserrat-Regular;
  }

  .show-float {
    display: none;
  }

  .float_button {
    margin: 0 auto;
    width: 320px;
    height: 60px;
    background: linear-gradient(135deg, #7D00FF 0%, #8F0AF5 49%, #FF5FA2 100%);
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    margin-top: 117px;
    cursor: pointer;
    border: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/CyclingApply.vue